import { openDB } from 'idb';

const DB_NAME = 'flowize-db';
const STORE_NAME = 'graphs';

export async function getDb() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        const store = db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
        store.createIndex('role', 'role');
      }
    }
  });
}

function sanitizeGraph(graph) {
  return JSON.parse(
    JSON.stringify(graph, (_key, value) =>
      typeof value === 'function' ? undefined : value
    )
  );
}

export async function saveGraph(graph) {
  const db = await getDb();
  const sanitized = sanitizeGraph(graph);
  await db.put(STORE_NAME, sanitized);
}

export async function deleteGraph(id) {
  const db = await getDb();
  await db.delete(STORE_NAME, id);
}

export async function getGraph(id) {
  const db = await getDb();
  return db.get(STORE_NAME, id);
}

export async function getGraphsByRole(role) {
  const db = await getDb();
  return db.getAllFromIndex(STORE_NAME, 'role', role);
}

export async function getAllGraphs() {
  const db = await getDb();
  return db.getAll(STORE_NAME);
}
